export default {
  moduleName: '公告管理'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/notice.js